<template>
  <div class="modal" @click.self="closeKanbanCardModal">
    <div class="complete">
      <div class="box">
        <button
          class="deleteCard"
          v-if="!cardSetToDelete"
          @click="cardSetToDelete = true"
        >
          {{ deletingCard ? "Deleting..." : "Delete" }}
        </button>
        <div class="helpers" v-if="cardSetToDelete">
          <button @click="deleteCard()" class="decider" style="font-size: 15px">
            Yes
          </button>
          <button
            @click="cardSetToDelete = false"
            class="decider"
            style="font-size: 15px"
          >
            No
          </button>
        </div>
        <input
          class="title"
          placeholder="Untitled card"
          :value="card.task"
          @input="updateCardTitle($event, card)"
        />
        <textarea
          class="subtitle"
          placeholder="No description"
          :value="card.description"
          @input="updateCardDescription($event, card)"
        ></textarea>
        <div class="confirm noselect" @click.self="closeKanbanCardModal">
          Close
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KanbanCardModal",
  props: ["card"],
  data() {
    return {
      cardSetToDelete: false,
      deletingCard: false,
    };
  },
  methods: {
    closeKanbanCardModal() {
      this.$emit("closeKanbanCardModal");
    },
    updateCardTitle($event, card) {
      const emitData = {
        event: $event,
        card: card,
      };
      this.$emit("updateCardTitle", emitData);
    },

    updateCardDescription($event, card) {
      const emitData = {
        event: $event,
        card: card,
      };
      this.$emit("updateCardDescription", emitData);
    },
    deleteCard() {
      this.$emit("deleteCard", this.card);
    },
  },
};
</script>

<style scoped>
.modal {
  position: absolute;
  z-index: 9999999999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: auto;
}

.complete {
  width: 765px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.complete .box {
  width: 100%;
  max-width: 980px;
  min-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 65px 20px;
  background-color: white;
  margin-bottom: 65px;
  margin-top: 25px;
  padding-bottom: 60px;
  border-radius: 25px;
  box-shadow: 0px 2px 2px 2px #5d5d5d45;
  border: 1px solid #eee;
  position: relative;

  /** EXPERIMENTAL */
  transform: scale(0.9);
}

.complete .box .title {
  font-size: 30px;
  width: 75%;
  border: none;
  text-align: center;
}

.complete .box .subtitle {
  font-size: 20px;
  width: 75%;
  white-space: normal;
  font-weight: 400;
  padding: 15px 15px 10px 15px;
  /* text-align: center; */
  margin: 0px auto;
  margin-top: 5px;
  line-height: 30px;
  border: 1px dashed #ccc;
  min-width: 250px;
  height: 400px;
}

.complete .box .subtext {
  white-space: normal;
  width: 75%;
  padding: 5px 0px;
  line-height: 27px;
  font-size: 20px;
  box-sizing: border-box;
  font-weight: 600;
  text-align: center;
  color: #2d2d2d;
}

.complete .box .confirm {
  font-size: 24px;
  outline: none;
  background-color: #0c0c0c;
  color: #ffffff;
  font-weight: 700;
  border: unset;
  padding: 12px 10px;
  width: 100%;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  margin-top: 30px;
  max-width: 150px;
  transition: 0.1s ease-in-out;
  text-align: center;
  border-radius: 360px;
}

.complete .box .confirm:hover {
  background-color: #49494c;
}

.complete .box .success-badge {
  height: 300px;
  width: 300px;
  padding: 20px 0px;
  padding-bottom: 0px;
  margin-bottom: 25px;
}

.helpers {
  position: absolute;
  right: 15px;
  top: 15px;
}

.decider {
  margin-left: 4px;
  margin-right: 4px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.deleteCard {
  border: none;
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 16px;
  cursor: pointer;
}
</style>